import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, ComunidadService, ConsorcioService, TipoComunidadService, TenantService } from '../../../../src/app/shared/services';
import { LocalStorageKeys, Comunidad, Consorcio, GridPageSettings, MenuFuncionCodes, SearchComunidadRequest, SearchConsorcioRequest, TipoComunidad } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants, SearchTipoComunidadRequest, SearchComunidadItemDto, TenantFeatureFlags } from '../../../../src/app/shared/model';

@Component({
  selector: 'app-comunidadLista',
  templateUrl: './comunidadLista.component.html',
  styles: [
  ]
})

export class ComunidadListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;
  consorcioList: Consorcio[];
  tipoComunidadList: TipoComunidad[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoComunidadSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  canEdit: boolean = false;
  canView: boolean = false;
  canAdd: boolean = false;
  verSoloActivos: boolean = true;
  public query: Query;

  tenantFeatureFlags: TenantFeatureFlags;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;


  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private service: ComunidadService,
    private tipoComunidadservice: TipoComunidadService,
    private consorcioService: ConsorcioService,
    private tenantService: TenantService,
    private datePipe: DatePipe) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.COMUNIDAD).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        if (data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_LIST)) {
          this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
            if (dataTenant != null && dataTenant.Success) {
              this.tenantFeatureFlags = dataTenant.Result;

              this.canAdd = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_ADD);
              this.canView = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_LIST);

              this.loadView();
            }
          },
          (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
          })
        } 
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.router.navigate(['/']);
        }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(), this.service.getTenantHeader()]
    });

    this.getConsorcio();
    this.getTipos();

  }

  getConsorcio() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return;

    var r = new SearchConsorcioRequest(null, null, null, "", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      if (data != null)
        this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTipos() {
    var r = new SearchTipoComunidadRequest(null, null, true, "Nombre", null, null, null, true);
    this.isTipoComunidadSearching = true;

    this.tipoComunidadservice.search(r).subscribe(data => {
      this.isTipoComunidadSearching = false;
      this.tipoComunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'Tipo': [null],
      'Nombre': [null],
      'ConsorcioId': [cId]
    });
  }

  onGridActionFailure(event: any): void {
    //console.log(event);
    //this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Tipo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Tipo;
    else
      this.query.addParams("Tipo", this.searchForm.value.Tipo);

    index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre", this.searchForm.value.Nombre);
    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId", this.searchForm.value.ConsorcioId);
    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos", this.verSoloActivos.toString());
  }

  add() {
    if(this.canAdd){
      this.router.navigate(['comunidad-edit', 0]);
    }else{
      this.sharedFunctions.showMessage("No tiene permisos para crear un nuevo item", "Error");
    }
  }

  edit(item: Comunidad) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['comunidad-edit', item.Id]);
  }

  onExport() {
    var search = new SearchComunidadRequest(null, null, null, "", null, null, null, null, null, this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = this.sharedFunctions.getNombreMenuTenant("Comunidad") + "_" + this.datePipe.transform(new Date(), "yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  showComunidadImage(item: SearchComunidadItemDto) {
    return (item?.FotoPerfilUrl != null && item?.FotoPerfilUrl?.length > 0);
  }
}
